import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    padding: "38",
  },
  section: {
    // margin: 20,
    // padding: 20,
    flexGrow: 1,
  },
  title: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#3c8dbc",
    textAlign: "center",
    marginBottom: 10,
  },
  header: {
    fontSize: 25,
    fontWeight: "bold",
    textAlign: "center",
    margin: 20,
  },
  address: {
    fontSize: 10,
    textAlign: "center",
    marginBottom: 10,
  },
  tableContainer: {
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  },
  table: {
    // display: "table",
    // width: "100%",
    // borderStyle: "dotted",
    // borderWidth: 1,
    // borderCollapse: "collapse",
    // borderBottom: 1,
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: 1,
    borderStyle: "dotted",
  },
  tableCell: {
    width: "33.33%",
    fontSize: "10",
    textAlign: "center",
    height: 25,
    margin: "auto",
    padding: 5,
    borderStyle: "dotted",
    borderBottom: 0,

  },
  header: {
    fontSize: "20",
    textAlign: "center",
    margin: "20",
  },

  agentName: {
    // displayL: "table",
    widtxh: "auto",
    textAlign: "left",
    borderStyle: "dotted",
    borderWidth: 1,
    borderCollapse: "collapse",
    marginBottom: 20,
  },
});

const PrintPassportList = () => {
  const data = [
    {
      name: "Md. Shahadat Hossain",
      passportNo: "123456789",
      ContactNumber: "01712345678",
      country: "USA",
      delivaryOffice: "Dhaka",
      agent: "Mr. X",
      contract: "123456",
      passportStatus: "Pending",
    },
    {
      name: "Md. Shahadat Hossain",
      passportNo: "123456789",
      ContactNumber: "01712345678",
      country: "USA",
      delivaryOffice: "Dhaka",
      agent: "Mr. X",
      contract: "123456",
      passportStatus: "Pending",
    },
  ];

  return (
    <PDFViewer style={{ width: "100%", height: "100vh" }}>
      <Document>
        <Page size="A4" style={styles.page} orientation="landscape">
          <View style={styles.section}>
            <Text style={styles.title}>Northeast Overseas LTD.</Text>
            <Text style={styles.address}>
              Gulfesha Plaza, 12/0, 69 Outer Circular Road, Boro Mogbazar,
              Dhaka-1217
            </Text>
            <Text style={styles.address}>
              Phone: +880241031411-2 || Email: info@northeastoverseas.com
            </Text>
            <Text style={styles.header}>PASSPORT LIST</Text>

            <Text style={styles.agentName}>
              Agent: Agent X
            
          </Text>

            <View style={styles.tableContainer}>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCell}>
                    <Text>SL</Text>
                  </View>
                  <View style={styles.tableCell}>
                    <Text>Name</Text>
                  </View>
                  <View style={styles.tableCell}>
                    <Text>Passport No.</Text>
                  </View>
                  <View style={styles.tableCell}>
                    <Text>Contact Number</Text>
                  </View>
                  <View style={styles.tableCell}>
                    <Text>Country</Text>
                  </View>
                  <View style={styles.tableCell}>
                    <Text>Delivery Office</Text>
                  </View>
                  <View style={styles.tableCell}>
                    <Text>Agent</Text>
                  </View>
                  <View style={styles.tableCell}>
                    <Text>Contract</Text>
                  </View>
                  <View style={styles.tableCell}>
                    <Text>Passport Status</Text>
                  </View>
                </View>
                {data.map((item, index) => (
                  <View style={styles.tableRow} key={index}>
                    <View style={styles.tableCell}>
                      <Text>{index + 1}</Text>
                    </View>
                    <View style={styles.tableCell}>
                      <Text>{item.name}</Text>
                    </View>
                    <View style={styles.tableCell}>
                      <Text>{item.passportNo}</Text>
                    </View>
                    <View style={styles.tableCell}>
                      <Text>{item.ContactNumber}</Text>
                    </View>
                    <View style={styles.tableCell}>
                      <Text>{item.country}</Text>
                    </View>
                    <View style={styles.tableCell}>
                      <Text>{item.delivaryOffice}</Text>
                    </View>
                    <View style={styles.tableCell}>
                      <Text>{item.agent}</Text>
                    </View>
                    <View style={styles.tableCell}>
                      <Text>{item.contract}</Text>
                    </View>
                    <View style={styles.tableCell}>
                      <Text>{item.passportStatus}</Text>
                    </View>
                  </View>
                ))}
              </View>
            </View>
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};

export default PrintPassportList;
